export default __webpack_public_path__ + "static/media/introduce_show_2.6c2cc5b2.png";